export default __webpack_public_path__ + "static/media/cog.7a4fb7d2.svg";